export default "__VITE_ASSET__BGxVCpro__"